angular.module("app.modalControllers").controller("ConfirmRevertConfigModalController", [
    '$scope',
    '$uibModalInstance',
    'preloadedData',
    function ($scope, $modalInstance, preloadedData) {

        $scope.configVersion = preloadedData;
        
        $scope.ok = function () {
            $modalInstance.close($scope.configVersion);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);